/** Shared section / page title classes — keep homepage and inner pages aligned. */
export const SECTION_TITLE_CLASS =
  "text-3xl font-medium tracking-tight md:text-4xl lg:text-[2.75rem] lg:leading-[1.15]";

export const PAGE_TITLE_CLASS =
  "max-w-4xl text-4xl font-medium tracking-tight md:text-6xl md:leading-[1.1]";
